import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormInput, CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CRow, CTabContent, CTabPane, CFormTextarea } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus } from 'lucide-react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveExtra from '../../services/general/saveExtraData.api'
import PlanSuggestionAccordian from '../../components/shared/PlanSuggestionAccordian'
import AccordianPlanSuggestion from './AccordianPlanSuggestion'
import ResonSuggestion from './ReasonSuggestion'
import PlanStatement from './PlanStatement'
import DifferentialCopy from './DifferentialCopy'

const PlanSuggestions = ({ parentSuggestionId, parentIndex, suggestionName, onAccordionsUpdate, planAccordions, selectedDiagnosis, ApiCallingType, handelSubmit, themeClassName = '' }) => {
  const [diagnosisData, setDiagnosisData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [suggestionModalVisible, setSuggestionModalVisible] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [currentDiagnosisId, setCurrentDiagnosisId] = useState(null)
  // const [selectedDiagnosis, setSelectedDiagnosis] = useState(null);
  const [diagnosisOptions, setDiagnosisOptions] = useState([])
  const [assessment, setAssessment] = useState([])
  const [plans, setPlans] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [suggestionId, setSuggestionId] = useState(null)

  const [currentParentId, setCurrentParentId] = useState(null)
  const [newTitle, setNewTitle] = useState('')
  const [suggestionTitle, setSuggestionTitle] = useState([])
  const [editMode, setEditMode] = useState(false)
  const [editingAccordionId, setEditingAccordionId] = useState(null)

  const [suggestionData, setSuggestionData] = useState([])
  const [suggestionIndex, setSuggestionIndex] = useState(null)
  const [activeDescriptions, setActiveDescriptions] = useState(null)

  const [saveResoanChange, setSaveResoanChange] = useState({})
  const [accordions, setAccordions] = useState(planAccordions?.accordions || [])

  const addAccordion = (parentId = null) => {
    if (editMode) {
      setAccordions((prev) => {
        const updatedAccordions = updateAccordionTitle(prev, editingAccordionId, newTitle)
        return updatedAccordions
      })
      setEditMode(false)
      setNewTitle(null)
    } else {
      let newAccordion
      //
      newAccordion = {
        id: Date.now(),
        title: newTitle,
        suggestions: {
          suggestionName: [],
          orders: [],
          planSuggestions: [],
          information: [],
        },
        children: [],
      }

      setAccordions((prev) => {
        const updatedAccordions = parentId ? updateNestedAccordions(prev, parentId, newAccordion) : [...prev, newAccordion]

        return updatedAccordions
      })
    }

    closeModal()
  }

  const updateAccordionTitle = (list, accordionId, newTitle) => list.map((item) => (item.id === accordionId ? { ...item, title: newTitle } : { ...item, children: updateAccordionTitle(item.children, accordionId, newTitle) }))

  const updateNestedAccordions = (list, parentId, newAccordion) => list.map((item) => (item.id === parentId ? { ...item, children: [...item.children, newAccordion] } : { ...item, children: updateNestedAccordions(item.children, parentId, newAccordion) }))

  useEffect(() => {
    onAccordionsUpdate(suggestionName, accordions)
  }, [accordions])

  const editAccordion = (accordionId, currentTitle) => {
    setEditMode(true)
    setEditingAccordionId(accordionId)
    setNewTitle(currentTitle)
    setModalVisible(true)
  }

  // const addSuggestion = (parentId = null) => {
  //     let suggestionText = suggestionTitle;

  //     if (suggestionText) {
  //         setAccordions((prev) => {
  //             if (parentId) {

  //                 const updatedSuggestions = updateNestedSuggestions(prev, parentId, suggestionText);
  //                 // onAccordionsUpdate(suggestionName, updatedSuggestions);
  //                 return updatedSuggestions;
  //             }
  //         });
  //     }

  //     setSuggestionTitle([]);
  //     setSuggestionModalVisible(false);
  // };

  const addSuggestion = (parentId = null) => {
    let suggestionText = suggestionTitle

    if (suggestionText?.length > 0) {
      setAccordions((prev) => {
        let updatedAccordions = prev

        if (!parentId && (!updatedAccordions || updatedAccordions.length === 0)) {
          const newAccordion = {
            id: Date.now(),
            title: null,
            suggestions: {
              suggestionName: suggestionText,
              orders: [],
              planSuggestions: [],
              information: [],
            },
            children: [],
          }
          updatedAccordions = [newAccordion]
        } else if (parentId) {
          updatedAccordions = updateNestedSuggestions(updatedAccordions, parentId, suggestionText)
        }

        return updatedAccordions
      })
    }

    setSuggestionTitle([])
    setSuggestionModalVisible(false)
  }

  const updateNestedSuggestions = (list, parentId, suggestion) =>
    list.map((item) =>
      item.id === parentId
        ? {
          ...item,
          suggestions: {
            ...item.suggestions,
            suggestionName: suggestion,
            orders: [],
            planSuggestions: [],
            information: [],
          },
        }
        : { ...item, children: updateNestedSuggestions(item.children, parentId, suggestion) },
    )

  const openModal = (parentId = null) => {
    setCurrentParentId(parentId)
    setModalVisible(true)
  }

  const closeModal = () => {
    setModalVisible(false)
    setNewTitle('')
    setEditingAccordionId(null)
    setEditMode(false)
  }

  const deleteAccordion = (accordionId) => {
    setAccordions((prev) => {
      const updatedAccordions = removeAccordionById(prev, accordionId)
      return updatedAccordions
    })
  }

  const removeAccordionById = (list, accordionId) =>
    list
      .filter((item) => item.id !== accordionId)
      .map((item) => ({
        ...item,
        children: removeAccordionById(item.children, accordionId),
      }))

  const deleteDiagnosis = async (e) => {
    // await SaveRisksData("DELETE", "", "", "", deleteVisibleId?.id);
    // Update local storage data
    let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []
    const updatedData = localData.filter((diagnosis) => diagnosis.id !== deleteVisibleId?.id)
    localStorage.setItem('SuggestionDiagnosis', JSON.stringify(updatedData))

    // Update state data
    getData()
    setDeleteVisibleId(null)
    setDiagnosisData(updatedData)
  }

  const handleOnClick = () => {
    setIsEditing(false)
    setCurrentDiagnosisId(null)
    // setSelectedDiagnosis(null);
    setAssessment([])
    setPlans([])
    setModalVisible(true)
    setCurrentParentId(null)
    // setSelectedSuggestion(null)
  }

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data

      let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []

      // setSuggestionData(localData)
      // let responseRisks = await GetDiagnosisData("Risks");
      // let localData = JSON.parse(responseRisks.d)?.Data;

      let data = await SaveExtra('Get_By_Type', 'planSuggestion', '', '')
      data = JSON.parse(data.d)?.Data || []
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setSuggestionData(data)
      updateDiagnosisOptions(diagnosis)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const updateDiagnosisOptions = (data) => {
    const options = data.map((item) => ({
      value: item.id,
      label: item.Name,
    }))
    setDiagnosisOptions(options)
  }

  useEffect(() => {
    getData()
  }, [])

  // useEffect(() => {
  //     if (accordions.length == 0) {
  //         addAccordion();
  //     }
  // }, [accordions])

  const editSuggestion = (parentId, suggestionIndex) => {
    const newSuggestion = suggestionTitle
    if (newSuggestion) {
      setAccordions((prev) => {
        const updatedSuggestions = updateEditNestedSuggestions(prev, parentId, suggestionIndex, newSuggestion)
        // onAccordionsUpdate(suggestionName, updatedSuggestions);
        return updatedSuggestions
      })
    }
    setSuggestionTitle([])
    setEditMode(false)
    setSuggestionModalVisible(false)
    setSuggestionIndex(null)
  }

  const updateEditNestedSuggestions = (list, parentId, suggestionIndex, newSuggestion) =>
    list.map((item) =>
      item.id === parentId
        ? {
          ...item,
          suggestions: {
            ...item.suggestions,
            suggestionName: newSuggestion,
          },
        }
        : {
          ...item,
          children: item.children ? updateEditNestedSuggestions(item.children, parentId, suggestionIndex, newSuggestion) : item.children,
        },
    )

  const handleSuggestionsChange = (updatedSuggestions, parentId) => {
    setAccordions((prev) => {
      const updatedData = updateNestedSuggestionsResoan(prev, parentId, updatedSuggestions)
      return updatedData
    })
    return true
  }

  const updateNestedSuggestionsResoan = (list, parentId, updatedSuggestions) =>
    list.map((item) =>
      item.id === parentId
        ? { ...item, suggestions: { ...item.suggestions, orders: updatedSuggestions } }
        : {
          ...item,
          children: updateNestedSuggestionsResoan(item.children || [], parentId, updatedSuggestions),
        },
    )

  const handlePlanSuggestionsChange = (updatedPlanSuggestions, parentId) => {
    setAccordions((prev) => {
      const updatedData = updatePlanSuggestionsForParent(prev, parentId, updatedPlanSuggestions)
      // onAccordionsUpdate(suggestionName, updatedData);
      return updatedData
    })
    return true
  }

  const updatePlanSuggestionsForParent = (list, parentId, updatedPlanSuggestions) =>
    list.map((item) =>
      item.id === parentId
        ? {
          ...item,
          suggestions: {
            ...item.suggestions,
            planSuggestions: updatedPlanSuggestions,
          },
        }
        : {
          ...item,
          children: updatePlanSuggestionsForParent(item.children || [], parentId, updatedPlanSuggestions),
        },
    )

  useEffect(() => {
    if (accordions?.length === 0) {
      addSuggestion()
    }
  }, [accordions])

  const [titleDescriptionId, setTitleDescriptionId] = useState('')
  const [descriptionText, setDescriptionText] = useState('')

  const handleAddTitleDescription = (item) => {
    setDescriptionText(item.description)
    setTitleDescriptionId(item.id)
  }

  const handleSaveDescription = () => {
    try {
      const updateDescriptionInNestedChildren = (data, id, descriptionText) => {
        if (!data || !Array.isArray(data)) {
          return false
        }

        for (const item of data) {
          if (item.id === id) {
            item.description = descriptionText
            return true
          }
          if (item.children && Array.isArray(item.children)) {
            const updated = updateDescriptionInNestedChildren(item.children, id, descriptionText)
            if (updated) return true
          }
        }
        return false
      }

      let updated = false
      if (accordions?.accordions) {
        updated = updateDescriptionInNestedChildren(accordions.accordions, titleDescriptionId, descriptionText)
      }

      if (updated) {
        console.log('Description updated successfully.')
      } else {
        console.log('Item not found.')
      }

      // setDescriptionText("")
      setTitleDescriptionId('')
    } catch (error) {
      console.log(error)
    }
  }

  const [descriptionStatementId, setDescriptionStatementId] = useState({
    orderIndex: '',
    parentId: '',
    name: '',
  })

  const [showDescriptionStatementModal, setShowDescriptionStatementModal] = useState(false)
  const [descriptionStatementText, setDescriptionStatementText] = useState('')

  const handleAddStatementDescription = (item, descriptionText) => {
    setShowDescriptionStatementModal(true)
    setDescriptionStatementId(item)
    setDescriptionStatementText(descriptionText)
  }

  const handleDescriptionStatementSubmit = () => {
    const updateNestedAccordion = (accordionList) => {
      return accordionList.map((accordion) => {
        if (accordion.id === descriptionStatementId.parentId) {
          const updatedSuggestionName = [...accordion.suggestions.suggestionName]

          updatedSuggestionName.forEach((suggestion) => {
            if (suggestion.name === descriptionStatementId.name) {
              suggestion.description = descriptionStatementText
            }
          })

          return {
            ...accordion,
            suggestions: {
              ...accordion.suggestions,
              suggestionName: updatedSuggestionName,
            },
          }
        }

        if (accordion.children && accordion.children.length > 0) {
          return {
            ...accordion,
            children: updateNestedAccordion(accordion.children),
          }
        }

        return accordion
      })
    }

    const updatedAccordions = updateNestedAccordion(accordions)

    accordions.accordions = updatedAccordions

    setDescriptionStatementId({
      name: '',
      parentId: '',
    })

    setActiveDescriptions(null)
  }

  const renderAccordions = (list, index) => {
    return (
      <div className=" ">
        <CRow>
          <div>
            {list?.map((item) => (
              <PlanSuggestionAccordian
                design={true}
                title={item.title}
                accordion={item}
                editAccordion={editAccordion}
                deleteAccordion={deleteAccordion}
                content={
                  <div className="mt-3">
                    {item.title && (
                      <div className="d-flex gap-2 justify-content-center ">
                        <CButton
                          variant="outline"
                          onClick={() => openModal(item.id)}
                          color="warning"
                          className="custom-button shadow-sm"
                          style={{
                            padding: '5px 10px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          Add Title
                        </CButton>
                        <CButton
                          variant="outline"
                          color="primary"
                          onClick={() => {
                            if (item.suggestions && !Array.isArray(item.suggestions) && item?.suggestions?.suggestionName.length > 0) {
                              item?.suggestions?.suggestionName?.map((s, index) => {
                                setSuggestionId(item.id)
                                setSuggestionModalVisible(true)
                                setSuggestionIndex(index)
                                setEditMode(true)
                                setSuggestionTitle(() => {
                                  let data = item?.suggestions?.suggestionName
                                  return data
                                })
                              })
                            } else {
                              setSuggestionId(item.id)
                              setSuggestionModalVisible(true)
                            }
                          }}
                          className={`custom-button shadow-sm `}
                          style={{
                            padding: '5px 10px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '500',

                          }}
                        >
                          Add/Edit Statement
                        </CButton>
                      </div>
                    )}

                    {item.suggestions && (
                      <ul className="list-group mt-4 mx-4">
                        <AccordianPlanSuggestion
                          suggestions={item?.suggestions?.suggestionName}
                          parentId={item.id}
                          orders={item?.suggestions?.orders}
                          onSuggestionsChange={handleSuggestionsChange}
                          setSaveResoanChange={setSaveResoanChange}
                          planSuggestions={item?.suggestions?.planSuggestions}
                          selectedDiagnosis={selectedDiagnosis}
                          handlePlanSuggestionsChange={handlePlanSuggestionsChange}
                          setParentAccordions={setAccordions}
                          information={item?.suggestions?.information || []}
                          handleAddStatementDescription={handleAddStatementDescription}
                          setActiveDescriptions={setActiveDescriptions}
                        />
                      </ul>
                    )}

                    {item.children.length > 0 && <div className="">{renderAccordions(item.children)}</div>}
                  </div>
                }
              />
            ))}
          </div>
        </CRow>
      </div>
    )
  }

  // const addAccordion = () => {
  //     const newAccordion = {
  //         id: Date.now(),
  //         title: "Default Title", // Customize as needed
  //         suggestions: [],
  //         children: [],
  //     };

  //     setAccordions((prev) => [...prev, newAccordion]);
  // };

  // useEffect to check if the accordions array is empty

  // useEffect(() => {
  //     if (accordions.length === 0) {
  //         addAccordion();

  //     }
  // }, [accordions]);

  return (
    <>
      <div className={themeClassName}>
        <div className="plan-suggestions-editor">
          <div className="plan-suggestions-editor__toolbar-wrap">
            <CCol className="d-flex flex-column align-items-center justify-content-start gap-2   " style={{ width: '100%', overflowY: 'auto', height: '100%' }}>
              <div className="  w-100" style={{ height: '100%' }}>
                <div className="d-flex justify-content-center gap-3 plan-suggestions-editor__toolbar">
                  <CButton
                    variant="outline"
                    onClick={handleOnClick}
                    color="warning"
                    className="custom-button shadow-sm"
                    style={{
                      padding: '5px 10px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '500',
                    }}
                  >
                    Add Title
                  </CButton>
                  <CButton
                    variant="outline"
                    color=""
                    onClick={() => {
                      // setSuggestionIndex(index)
                      setSuggestionModalVisible(true)

                      if (accordions.length > 0) {
                        setEditMode(true)
                        setSuggestionId(accordions[0]?.id)
                        setSuggestionTitle(() => {
                          let data = accordions[0]?.suggestions?.suggestionName || []
                          return data
                        })
                      } else {
                        setSuggestionId(null)
                      }
                    }}
                    className="custom-button shadow-sm general-plan-statements-theme__statement-button"
                    style={{
                      padding: '5px 10px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '500',
                    }}
                  >
                    Add/Edit Statements
                  </CButton>
                </div>
              </div>
            </CCol>
          </div>

          <div className="  ">{renderAccordions(accordions)}</div>

          {/* <div className=""  >
                       <CButton color="primary" onClick={handlePlanSuggestionSave}>Save</CButton>
                    </div> */}
        </div>

        <CModal
          className={themeClassName ? `patient-theme-modal ${themeClassName}` : undefined}
          backdrop="static"
          size="md"
          visible={modalVisible}
          onClose={() => {
            setModalVisible(false)
            setAssessment([])
            setPlans([])
            setEditMode(false)
            setNewTitle(null)
          }}
        >
          <CModalHeader
            onClose={() => {
              setModalVisible(false)
              setAssessment([])
              setPlans([])
              setNewTitle(null)
            }}
          >
            <CModalTitle>{editMode ? 'Edit Title' : 'Add Title'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {modalVisible && (
              <>
                <div className="border mt-0 p-2 py-4 rounded">
                  <div className="w-100">
                    <p className="font-weight-large mb-2" style={{ fontSize: '13px' }}>
                      Title
                    </p>
                    <CFormInput name="Title" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} type="text" placeholder="" className="h-25" />
                  </div>
                </div>
              </>
            )}
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              className="ui-action-btn ui-action-btn--secondary"
              onClick={() => {
                setModalVisible(false)
                setKeywords([])
                setPlans([])
                setEditingAccordionId(null)
                setEditMode(false)
                setNewTitle(null)
              }}
            >
              Close
            </CButton>
            <CButton color="primary" className="ui-action-btn ui-action-btn--primary" onClick={() => addAccordion(currentParentId)}>
              {isLoading ? (
                <>
                  <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                  Loading...
                </>
              ) : editMode ? (
                'Save '
              ) : (
                'Save '
              )}
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          className={themeClassName ? `patient-theme-modal ${themeClassName}` : undefined}
          backdrop="static"
          size="lg"
          visible={suggestionModalVisible}
          onClose={() => {
            setSuggestionModalVisible(false)
            setSuggestionTitle([])
            setEditMode(false)
          }}
        >
          <CModalHeader
            onClose={() => {
              setSuggestionModalVisible(false)
              setSuggestionTitle([])
              setEditMode(false)
            }}
          >
            <CModalTitle>{isEditing ? 'Edit Statement' : 'Add Statement'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {suggestionModalVisible && (
              <>
                <div className=" mt-0 p-2 py-4 rounded">
                  <div className="w-100">
                    <div className="w-100 p-3 rounded pe-title-card assessment-plan-suggestion-theme__statement-panel">
                      {/* <ResonSuggestion className='mb-3' label='Statement' keywords={suggestionTitle} setKeywords={setSuggestionTitle} setParentAccordions={setAccordions} parentId={suggestionId} setSuggestionModalVisible={setSuggestionModalVisible} /> */}
                      <PlanStatement
                        className="mb-3"
                        handleSubmitWhenTabChange={() => handelSubmit?.(false, false)}
                        label="Statement"
                        keywords={suggestionTitle}
                        setKeywords={setSuggestionTitle}
                        setParentAccordions={setAccordions}
                        parentId={suggestionId}
                        setSuggestionModalVisible={setSuggestionModalVisible}
                        type="plan"
                        differentModuleCopyFunctionality={true}
                        ApiCallingType={ApiCallingType}
                      />
                    </div>
                    {/* <div>
                                            <AccordianSuggestion
                                                suggestions={suggestionTitle}
                                                onSuggestionsChange={handleSuggestionsChange}
                                                parentId={suggestionId}
                                            />
                                        </div> */}
                  </div>
                </div>
              </>
            )}
          </CModalBody>

          <CModalFooter>
            <CButton
              color="secondary"
              className="ui-action-btn ui-action-btn--secondary"
              onClick={() => {
                setSuggestionModalVisible(false)
                setSuggestionTitle([])
                setEditMode(false)
              }}
            >
              Close
            </CButton>
            <CButton
              color="primary"
              className="ui-action-btn ui-action-btn--primary"
              onClick={() => {
                ; (setSuggestionModalVisible(false), editMode ? editSuggestion(suggestionId, suggestionIndex) : addSuggestion(suggestionId))
              }}
            >
              {isLoading ? (
                <>
                  <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                  Loading...
                </>
              ) : (
                'Save'
              )}
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal className={themeClassName ? `patient-theme-modal ${themeClassName}` : undefined} backdrop="static" visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={deleteDiagnosis} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal className={`patient-theme-modal assessment-plan-suggestion-theme__modal ${themeClassName}`.trim()} size="lg" alignment="top" backdrop="static" visible={activeDescriptions} onClose={() => setActiveDescriptions(null)} aria-labelledby="VerticallyCenteredExample">
          <CModalHeader className="text-warning">
            <CModalTitle id="VerticallyCenteredExample" className=" ">
              Description
            </CModalTitle>
          </CModalHeader>
          <CModalBody className="assessment-plan-suggestion-theme__modal-body">
            <div>
              <div className="pe-tab-underline-nav mb-4">
                <CNav role="tablist" className="justify-content-center">
                  <CNavItem>
                    <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                      New
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink
                      active={activeTab === 1}
                      onClick={() => {
                        setActiveTab(1)
                      }}
                    >
                      Copy
                    </CNavLink>
                  </CNavItem>
                </CNav>
              </div>
              <div activeTab={activeTab} onActiveTabChange={setActiveTab}>
                <CTabContent>
                  {activeTab === 0 && (
                    <CTabPane visible={activeTab === 0}>
                      {activeDescriptions == 'statement' && (
                        <div>
                          <div className="mx-5">
                            <CFormTextarea
                              id="descriptionTextarea"
                              label="Enter your description"
                              style={{ height: '200px', color: '#ffc107', caretColor: 'black' }}
                              placeholder="Type your description here..."
                              value={descriptionStatementText}
                              onChange={(e) => {
                                setDescriptionStatementText(e.target.value)
                              }}
                            />
                          </div>

                          <div className="mx-5 my-2 m-0 d-flex justify-content-end gap-2">
                            <CButton
                              color="secondary"
                              className="ui-action-btn ui-action-btn--secondary"
                              onClick={() => {
                                ; (setTitleDescriptionId(''), setActiveDescriptions(null))
                              }}
                            >
                              Close
                            </CButton>
                            <CButton
                              color="primary"
                              onClick={handleDescriptionStatementSubmit}
                              className="ui-action-btn ui-action-btn--primary"
                            >
                              Save
                            </CButton>
                          </div>
                        </div>
                      )}
                      {activeDescriptions == 'title' && (
                        <div>
                          <div className="mx-5">
                            <CFormTextarea
                              style={{ height: '200px', color: '#ffc107', caretColor: 'black' }}
                              className="form-control"
                              value={descriptionText}
                              onChange={(e) => {
                                setDescriptionText(e.target.value)
                              }}
                              placeholder="Enter Description"
                            ></CFormTextarea>
                          </div>
                          <div className="mx-5 my-2 m-0 d-flex justify-content-end gap-2">
                            <CButton
                              color="secondary"
                              className="ui-action-btn ui-action-btn--secondary"
                              onClick={() => {
                                ; (setTitleDescriptionId(''), setActiveDescriptions(null))
                              }}
                            >
                              Close
                            </CButton>
                            <CButton
                              color="primary"
                              onClick={handleSaveDescription}
                              className="ui-action-btn ui-action-btn--primary"
                            >
                              Save
                            </CButton>
                          </div>
                        </div>
                      )}
                    </CTabPane>
                  )}
                  {activeTab === 1 && (
                    <CTabPane visible={activeTab === 1} className=" w-100 d-flex flex-column  justify-content-center align-items-center">
                      <div className="w-100">
                        <DifferentialCopy
                          setDescriptionStatementText={setDescriptionStatementText}
                          setActiveTab={setActiveTab}
                          descriptionStatementId={descriptionStatementId}
                          setParentAccordions={setAccordions}
                          ApiCallingType={'AssesmentSuggestions'}
                          parentId={currentParentId}
                          setSuggestionModalVisible={setSuggestionModalVisible}
                          type={'plan'}
                          titleDescriptionId={titleDescriptionId}
                          activeDescriptions={activeDescriptions}
                          setDescriptionText={setDescriptionText}
                        />
                      </div>
                    </CTabPane>
                  )}
                </CTabContent>
              </div>
            </div>
          </CModalBody>

          {/* <CModalFooter>
                        <CButton variant="outline" color="secondary" onClick={() => setActiveDescriptions(null)}>
                            Close
                        </CButton>
                        <CButton
                            variant="outline"

                            color="primary">Save</CButton>
                    </CModalFooter> */}
        </CModal>
        {/* <Pageloader isLoading={isPageLoading} /> */}
      </div>
    </>
  )
}

export default PlanSuggestions
